
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetMembervideosQuery } from '../../../store/api/member';
import Loadercomp from "../../../components/common/Loadercomp";
import ConfirmationModal from '../../../components/common/List/DeletePopup';

import Pagination from '../../../components/common/List/Pagination';


const extractYouTubeId = (url) => {
  const regex = /(?:youtu\.be\/|youtube\.com(?:\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)))([A-Za-z0-9_-]{11})/;
  const match = url.match(regex);
  return match ? match[1] : null;
};
const VideoCard = ({ video }) => {
  const videoId = extractYouTubeId(video.link);

  const renderVideo = () => {
    if (videoId) {
      return (
        <iframe
          className="w-full h-52 object-cover rounded-md"
          src={`https://www.youtube.com/embed/${videoId}`}
          title={video.title}
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      );
    }

    if (video.video) {
      const videoUrl = `${process.env.REACT_APP_API_URL}${video.video}`;
      return (
        <video className="w-full h-52 object-cover rounded-md" controls>
          <source src={videoUrl} type="video/mp4" />
          <source src={videoUrl.replace('.mp4', '.webm')} type="video/webm" />
          Your browser does not support the video tag.
        </video>
      );
    }

    if (video.thumb_image) {
      const photoUrl = `${process.env.REACT_APP_API_URL}${video.thumb_image}`;
      return <img src={photoUrl} alt={video.title} className="w-full h-52 object-cover rounded-md" />;
    }

    return (
      <div className="w-full h-52 flex items-center justify-center bg-gray-200 rounded-lg">
        <p className="text-gray-500">No video available</p>
      </div>
    );
  };

  return (
    <div className="bg-gray-200  px-5 shadow-lg rounded-lg p-3 w-full h-80 flex flex-col justify-between">
      <div className='mt-5'>
      {renderVideo()}
      </div>
      <div className="mt-2 p-3">
        <h3 className="text-lg font-semibold">{video.title}</h3>
        <p className="text-sm text-black truncate">{video.description}</p>
      </div>
    </div>
  );
};


function MemberVideo() {
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1)
  const { data, isLoading, error, refetch } = useGetMembervideosQuery({
    page: currentPage,
    page_size: pageSize,
  });

  const nvg = useNavigate();

  const videos = Array.isArray(data?.data) ? data.data : [];

  // console.log("videos", data.count)


  useEffect(() => {
    refetch();
  }, [refetch]);

  return isLoading ? (
    <Loadercomp />
  ) : error ? (
    <div className="text-red-500 text-center">Error loading videos: {error.message}</div>
  ) : (
    <div className="w-full mx-auto py-3">
      <div className="py-4 bg-white rounded-lg shadow-lg">
        <div className="flex justify-between">
          <div className="flex justify-between items-center mb-6 px-3">
            <h1 className="text-lg font-bold text-lightdark text-center">Videos List</h1>
          </div>
        </div>

        {videos.length === 0 ? (
          <p className='text-lg font-bold text-lightdark text-center'>No Videos Available</p>
        ) : (
          <div className="grid mx-5 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {videos.map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>)}
        {pageSize != 0 ? <Pagination
          setCurrentPage={setCurrentPage}
          data={videos}
          pageSize={pageSize}
          totalrecords={data?.data.count || 12}
        /> : ''}

      </div>
    </div>
  );
}

export default MemberVideo
